import React from 'react';
import { useIsMutating } from 'react-query';
import { EntireLoader } from 'renderer/components';
export var MutateLoader = function () {
    var isMutating = useIsMutating();
    return React.createElement(EntireLoader, { open: isMutating >= 1 });
};
